"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploReportBuilderApiStructureSchema = exports.ExploDashboardApiStructureSchema = exports.ExploArtifactOptions = exports.ExploPlacement = void 0;
const zod_1 = require("zod");
// Recall to update GQL type when updating this
var ExploPlacement;
(function (ExploPlacement) {
    ExploPlacement.CreditFacilityOptions = [
        'lenderFacilitiesTab',
        'borrowerStratsPage',
    ];
    ExploPlacement.OrganizationOptions = [
        'lenderPortfolioTab',
        'limitedPartnersDashboard',
    ];
    ExploPlacement.AllOptions = [
        ...ExploPlacement.CreditFacilityOptions,
        ...ExploPlacement.OrganizationOptions,
    ];
    ExploPlacement.isExploCreditFacilityOptionType = (type) => {
        return ExploPlacement.CreditFacilityOptions.includes(type);
    };
    ExploPlacement.isExploOrganizationOptionType = (type) => {
        return ExploPlacement.OrganizationOptions.includes(type);
    };
})(ExploPlacement || (exports.ExploPlacement = ExploPlacement = {}));
exports.ExploArtifactOptions = ['dashboard', 'reportBuilder'];
// *********************************************
//          Explo API Return Structures
// *********************************************
/**
 * --- Explo Dashboard Artifact ---
 * API Reference: https://docs.explo.co/api-reference/resource-api/get-dashboard
 */
const ExploDashboardAttributeSchema = zod_1.z.object({
    attribute: zod_1.z.string(),
    value: zod_1.z.string(),
});
exports.ExploDashboardApiStructureSchema = zod_1.z.object({
    team_id: zod_1.z.number(),
    name: zod_1.z.string(),
    embed_id: zod_1.z.string(),
    attributes: zod_1.z.array(ExploDashboardAttributeSchema),
});
/**
 * --- Explo Report Builder Artifact ---
 * API Reference: https://docs.explo.co/api-reference/resource-api/list-report-builders
 */
exports.ExploReportBuilderApiStructureSchema = zod_1.z.object({
    name: zod_1.z.string(),
    embed_id: zod_1.z.string(),
});
//# sourceMappingURL=Explo.js.map